class ProductsGrid extends HTMLElement {
  constructor() {
    super();

    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 1.3,
      spaceBetween: 18,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      breakpoints: {
        550: {
          slidesPerView: 1.6,
        },
        750: {
          slidesPerView: 1.8,
        },
        990: {
          slidesPerView: 2.2,
        },
        1240: {
          slidesPerView: 4,
        },
      },
    });
  }
}

customElements.define("products-grid", ProductsGrid);
